import { jsx as _jsx } from "react/jsx-runtime";
import { Global } from '@emotion/react';
import { system } from '@config/system';
import { ROOT_SELECTOR } from '@view/constants/root';
import { css, getParentSelector } from './helpers';
// To ensure the Immersive Experience works correctly on Wix,
// the minimum viewport must be less than or equal to 280px.
// However, to keep a small safety margin, we will set it to 256px,
// which is also a power of two.
const MIN_VIEWPORT_WIDTH = 256;
// Hosted page scrolls the document, so the root must grow with content to keep
// the background behind it. Immersive popup scrolls inside a fixed-height root.
export const ROOT_HEIGHT_PROPERTY = system.isHostedExperience
    ? 'min-height'
    : 'height';
export const RootStyles = () => (_jsx(Global, { styles: css `
      ${getParentSelector(ROOT_SELECTOR)} {
        background-color: var(--booking-engine-colors-background-500);
        ${ROOT_HEIGHT_PROPERTY}: 100%;
        min-width: ${MIN_VIEWPORT_WIDTH}px;
        transition-property: background-color;
        transition-duration: var(--chakra-transition-duration-normal);
      }
    ` }));
